import Papa from 'papaparse';

export type StateStats = {
  moneyCr?: number;
  smartphonePct?: number;
  urbanPct?: number;
  housingIdx?: number;
};

const aliases: Record<string, string> = {
  'nct of delhi': 'delhi',
  'orissa': 'odisha',
  'uttaranchal': 'uttarakhand',
  'jammu & kashmir': 'jammu and kashmir',
};

export const normalizeState = (name: string) => {
  const cleaned = name.toLowerCase().replace(/\s+/g, ' ').trim();

  return aliases[cleaned] || cleaned;
};

async function loadCSV(path: string): Promise<any[]> {
  const response = await fetch(path);
  const text = await response.text();

  return new Promise((resolve) => {
    Papa.parse(text, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        resolve(results.data as any[]);
      },
    });
  });
}

export async function loadStateData() {
  const [
    urbanRows,
    moneyRows,
    housingRows,
    phoneRows,
  ] = await Promise.all([
    loadCSV('/data/urban_pct.csv'),
    loadCSV('/data/upi_money_transferred.csv'),
    loadCSV('/data/housing_index.csv'),
    loadCSV('/data/smartphone_penetration.csv'),
  ]);

  const stateMap: Record<string, StateStats> = {};

  urbanRows.forEach((r) => {
    const key = normalizeState(r.state);

    if (!stateMap[key]) stateMap[key] = {};

    stateMap[key].urbanPct = Number(r.urbanPct);
  });

  moneyRows.forEach((r) => {
    const key = normalizeState(r.state);

    if (!stateMap[key]) stateMap[key] = {};

    stateMap[key].moneyCr = Number(r.moneyCr);
  });

  housingRows.forEach((r) => {
    const key = normalizeState(r.state);

    if (!stateMap[key]) stateMap[key] = {};

    stateMap[key].housingIdx = Number(r.housingIdx);
  });

  phoneRows.forEach((r) => {
    const key = normalizeState(r.state);

    if (!stateMap[key]) stateMap[key] = {};

    stateMap[key].smartphonePct = Number(r.smartphonePct);
  });

  return stateMap;
}